import { ApiForImage } from './../../../../shared/Models/lookup/appSetting';
import { CampaignService } from './../../../../shared/API-Service/services/campaign.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-insert-campaign',
  templateUrl: './insert-campaign.component.html',
  styleUrls: ['./insert-campaign.component.css']
})
export class InsertCampaignComponent extends BaseComponent implements OnInit, OnDestroy {
  public InsertForm: FormGroup;
  public update: boolean = false;
  public submit: boolean = true;
  public validated: boolean;
 
  private logoForm: FormData;
  public imageSrc: string;
  private imgFile: File;
  inactive: boolean=true;

  subscription = new Subscription();

  constructor(
    private _CampaignService: CampaignService,
    private fb: FormBuilder,
    private _router: Router,
    private translate: TranslateService,
    private readonly _activatedRoute: ActivatedRoute

  ) {
    super();
  }

  get fc() {
    return this.InsertForm.controls;
  }


  ngOnInit(): void {
    this.initiate()
    this.init()
  }

  private init() {
    if (typeof this._activatedRoute.snapshot.params["id"] !== "undefined") {
      let id = this._activatedRoute.snapshot.params["id"];
      id !== null ? this.GetCampaignById(id) : this.initiate();
    } else
      this.initiate()

  }



  private initiate(campaign?: any) {
    this.InsertForm = this.fb.group({
      title: [campaign?.title || '', Validators.required],
      description: [campaign?.description || '', Validators.required],
      image: [''],
    });
  }



  // getToasterMessage(): any {
  //   return this.getSwalSuccessMessage(
  //     'Country',
  //     this.update,
  //     this.update
  //       ? this.country.title
  //       : this.InsertForm.value.title
  //   );
  // }



  public onSubmit() {
    if (this.InsertForm.status == "VALID") {
      this.validated = false;
      if (this.imageSrc) {
        if (this.update == true) {
          this.Edit();
        } else {
          this.insertData();
        }
      } else {
        Swal.fire({
          icon: "error",
          title: this.translate.instant("Image must be selected"),

          showConfirmButton: false,
          timer: 1500,
        });
      }

    } else {
      this.validated = true;
    }
  }

  private insertData() {
    this.loopform(); this.submit = false;
    this.subscription.add(this._CampaignService.Post(this.logoForm).subscribe((res) => {
      this._router.navigate(['/content/admin/List-Campaign']);
      this.InsertForm.reset();
      Swal.fire({
        icon: "success",
        title: this.translate.instant('Inserted Success'),
        showConfirmButton: false,
        timer: 1500,
      });
    }, (err) => {
      this.submit = true

    }
    ));
  }

  private Edit() {
    this.loopform()
    this.submit = false
    this.subscription.add(this._CampaignService.put(this.logoForm).subscribe((res) => {
      this._router.navigate(['/content/admin/List-Campaign']);
      this.InsertForm.reset();

      Swal.fire({
        icon: "success",
        title: this.translate.instant('Updated Success'),
        showConfirmButton: false,
        timer: 1500,
      });
  
    }, (err) => {
      this.submit = true

    }
    ));
  }
  public onFileChange(event) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      this.imgFile = file;
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imageSrc = reader.result as string;

        this.InsertForm.patchValue({
      image: reader.result,
        });
      };
    }
  }

  private GetCampaignById(id: number) {
    this.subscription.add(this._CampaignService.GetCampaignById(id).subscribe((res) => {
      if (res.message == "Sucess") {
        this.imageSrc = ApiForImage + res.data.image;
        this.inactive=res.data.inactive
        this.initiate(res.data);
        this.update = true
        this.InsertForm.addControl('id', new FormControl(res.data.id));

      }
    }));
  }
  inactiveChange(){
    if(this.inactive){
      this.inactive=false;
    }
    else{
          this.inactive=true;
    }   
  }

  public checkType(imge) {
    console.log(imge)
    
    const before_ = imge.substring(-1, imge.indexOf("/"));

    if (before_ == "image") {

      return true
    } else {
      Swal.fire({
        icon: "error",
        title: 'Media type is not supported',
        showConfirmButton: false,
        timer: 1500,
      });
      return false

    }
  }
  private loopform() {
    this.logoForm = new FormData();
    Object.keys(this.InsertForm.value).forEach(key => {
      if (typeof this.InsertForm.value[key] !== 'object')

        this.logoForm.append(key, this.InsertForm.value[key])
      else
        Object.keys(this.InsertForm.value[key]).forEach(subkey => { this.logoForm.append(key, this.InsertForm.value[key][subkey]) })
    })
    this.logoForm.append('Inactive', String(this.inactive))

    if(this.imgFile !=null)
    this.logoForm.append('campaignImage', this.imgFile)
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe()
  }
}